/**
 * Bus: apiClient notifies when BE returns DEMO_TOUR_WRITE_DENIED (D4)
 * so FE can toast without treating sessionStorage as auth.
 */

type DemoTourWriteDeniedListener = () => void;

const listeners = new Set<DemoTourWriteDeniedListener>();

export const DEMO_TOUR_WRITE_DENIED_CODE = 'DEMO_TOUR_WRITE_DENIED' as const;

export function notifyDemoTourWriteDenied(): void {
  for (const listener of listeners) {
    listener();
  }
}

export function subscribeDemoTourWriteDenied(
  listener: DemoTourWriteDeniedListener,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function isDemoTourWriteDeniedError(error: unknown): boolean {
  if (error == null || typeof error !== 'object') {
    return false;
  }
  const code = (error as { code?: unknown }).code;
  return code === DEMO_TOUR_WRITE_DENIED_CODE;
}
